/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "context";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

export default function Permissions() {
  const { user } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchedDeadlines = async () => {
      try {
        const response = await fetch(`${apiUrl}/dashboard/permissions.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.id,
            isAdmin: user.isAdmin ? user.isAdmin : false,
          }),
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        // Fetch files for each permission
        const updatedData = await Promise.all(
          data.map(async (element) => {
            const userDocResponse = await fetch(`${apiUrl}/file_list.php`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                user_id: element.user_id,
                path: `Permission/${element.permission_multiselect_id}`,
              }),
            });

            const userDocResult = await userDocResponse.json();
            const files = userDocResult.message.files;

            // Return the element with files added to it
            return { ...element, files };
          })
        );
        setData(updatedData);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setLoading(false); // Set loading to false when fetch completes
      }
    };

    if (user.id) {
      fetchedDeadlines();
    }
  }, [user]);

  const downloadFile = (file, permission_multiselect_id, user_id) => {
    const url = `${apiUrl}/uploads/${user_id}/Permission/${permission_multiselect_id}/${file}`;
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = file;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  // While fetching data, return loading as true
  if (loading) {
    return { columns: [], rows: [], loading: true };
  }

  const columns = [
    {
      Header: "evento",
      accessor: "event_name",
      sortType: "alphanumeric",
      align: "left",
      Cell: ({ row }) => (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          <Link to={`/app/event/${row.original.event_id}`}>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
              title={`${row.original.address_city} - ${row.original.event_name}`}
            >
              {`${row.original.address_city} - ${row.original.event_name}`.length > 25
                ? `${`${row.original.address_city} - ${row.original.event_name}`.slice(0, 22)}...`
                : `${row.original.address_city} - ${row.original.event_name}`}
            </MDTypography>
          </Link>
        </MDBox>
      ),
    },
    {
      Header: (
        <MDBox display="flex" alignItems="center" color="secondary">
          permesso
          <Icon sx={{ ml: 1 }}>download</Icon> {/* Add download icon */}
        </MDBox>
      ),
      accessor: "permission",
      align: "left",
      sortType: "alphanumeric",
      Cell: ({ row }) => (
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          onClick={() => downloadFile(row.original.files[0], row.original.id, row.original.user_id)}
          style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
        >
          {row.original.files[0] ? row.original.files[0] : "No File"}
        </MDTypography>
      ),
    },
  ];

  const rows = data.map((data) => ({
    id: data.permission_multiselect_id,
    user_id: data.user_id,
    permission_id: data.permission_id,
    event_id: data.event_id,
    event_name: data.event_name,
    address_city: data.event_address.city,
    files: data.files, // Save files here
  }));

  return {
    columns,
    rows,
    loading: false, // Add loading status as false when data is available
  };
}

